import React, { useState, useEffect } from 'react';
import { RightOutlined } from '@ant-design/icons';
import { message, Spin } from 'antd';
import editGroupIcon from '../../../../assets/icons/editGroup.svg';
import binGroup from '../../../../assets/icons/binGroup.svg';

import {
  getListaConsultas,
  getDadosCadastraisConsulta,
} from '../../../../services/cadastroConsulta';

import * as S from '../styles';

export function GridConsultas({
  inputBusca,
  setEditConsult,
  setConsulta,
  setIsModalVisible,
  isModalVisible,
  reloadGrid,
}) {
  const [loadingListaConsulta, setLoadingListaConsulta] = useState(false);
  const [activeId, setActiveId] = useState(0);
  const [consultas, setConsultas] = useState([]);

  const filtered = consultas?.filter(item => {
    if (item?.nome) {
      const concat = item.nome.concat(item?.fornecedor?.nome);
      return concat.toLowerCase().includes(inputBusca.toLowerCase());
    }
    return null;
  });

  const getListaConsulta = async () => {
    setLoadingListaConsulta(true);
    try {
      const response = await getListaConsultas();
      if (response?.status === 200) {
        setConsultas(response?.data?.items || []);
        setLoadingListaConsulta(false);
      }
      if (response?.status !== 200) {
        message.error('Não encontramos nenhuma consulta no momento');
        setLoadingListaConsulta(false);
      }
    } catch (error) {
      message.error('Não foi possivel buscar a lista de consultas.');
      setLoadingListaConsulta(false);
    }
  };

  useEffect(() => {
    getListaConsulta();
  }, [reloadGrid]);

  const handleEdit = async id => {
    setActiveId(id);
    try {
      const response = await getDadosCadastraisConsulta(id);
      if (response?.status === 200) {
        setEditConsult(response.data);
      } else {
        message.error(
          'Não foi possível buscar os dados cadastrais da consulta.'
        );
      }
    } catch (error) {
      message.error('Não foi possível buscar os dados cadastrais da consulta.');
    }
  };

  const remove = item => {
    setConsulta(item);
    setIsModalVisible(!isModalVisible);
  };

  useEffect(() => {
    getListaConsulta();
  }, []);

  return (
    <Spin
      spinning={loadingListaConsulta}
      size="large"
      style={{
        width: '100%',
      }}
      tip="Carregando lista de Consultas"
      delay={200}
    >
      {filtered?.map((item, i) => (
        <S.RowsForColumn key={i} active={activeId === item.id}>
          <S.RowData
            style={{ color: '#828282', cursor: 'initial' }}
            key={item.id}
            justify="center"
            span={24}
          >
            <S.StyledColRow
              style={{ cursor: 'pointer' }}
              onClick={() => handleEdit(item.id)}
              span={6}
            >
              {item.nome || ''}
            </S.StyledColRow>
            <S.StyledColRow
              style={{ cursor: 'pointer' }}
              onClick={() => handleEdit(item.id)}
              span={6}
            >
              {item?.fornecedor || ''}
            </S.StyledColRow>
            <S.StyledColRow
              span={6}
              style={{ cursor: 'pointer' }}
              onClick={() => handleEdit(item.id)}
            >
              <img
                onClick={() => handleEdit(item.id)}
                src={editGroupIcon}
                alt="edit"
              />
{' '}
            </S.StyledColRow>
            <S.StyledColRow span={5}>
              <img
                style={{ cursor: 'pointer' }}
                src={binGroup}
                alt="bin"
                onClick={() => remove(item.id)}
              />
            </S.StyledColRow>
            <S.StyledColRow span={1}>
              <RightOutlined />
            </S.StyledColRow>
          </S.RowData>
        </S.RowsForColumn>
      ))}
    </Spin>
  );
}
